jQuery(document).ready(function ($) {
  // Simple accordion functionality
  $('.accordion__group button').on('click', function (e) {
    e.preventDefault();
    AOS.refresh();

    // If item clicked on is open, close it
    if ($(this).closest('.accordion__group').hasClass('active')) {
      $(this).closest('.accordion__group').removeClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideUp();
    } else {
      // Otherwise, close all others and open the one clicked on
      $('.accordion__group').removeClass('active');
      $('.accordion__copy').slideUp();
      $(this).closest('.accordion__group').addClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideToggle();
    }
  });
});
jQuery(document).ready(function ($) {
  // Show / hide address add form
  $('.customer--addresses .add-address').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });

  // Show / hide address add form
  $('.customer--addresses .add-address-cancel').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });
});
jQuery(document).ready(function ($) {
  $('.shopify-product-form').on('submit', function (e) {
    e.preventDefault();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function success() {
        successState();
      },
      error: function error() {
        // Do something on error (e.g. show an error message)
      }
    });
  });

  /******************************************
     QTY Selector ( Simple quantity box increase / decrease )
    ******************************************/

  // PDP / PLP
  $('.js-qty:not(.js-qty--cart)').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 0 : qtyInputVal;
    }
    qtyInput.val(qtyInputVal);
  });
  $('body').on('click', '.product--default .btn--atc', function () {
    var id = $(this).attr('data-id');
    CartJS.addItem(parseInt(id), 1, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        //error state
        console.log('Error: ' + errorThrown + '!');
      }
    });
  });

  // MAIN CART
  $('.col__qty, .mobile-stuff').on('click', '.js-qty--cart', function (e) {
    e.preventDefault();
    var $this = $(this);
    var qtyInput = $this.closest('.qty').find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var lineNum = $this.closest('.cart-row').attr('data-linenum');
    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }
    if (qtyInputVal >= 1) {
      CartJS.updateItem(lineNum, qtyInputVal, {}, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(jqXHR.responseText);
        }
      });
    } else {
      CartJS.removeItem(lineNum, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(jqXHR.responseText);
        }
      });
    }
  });

  // MAIN CART REMOVE
  $('.actions .remove-product').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var lineID = $this.closest('.cart-row').attr('data-lineid');
    CartJS.removeItemById(lineID, {
      success: function success(data, textStatus, jqXHR) {
        location.reload();
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  });

  /******************************************
     Options to change SM-RC Widget dropdowns
    ******************************************/

  // SELECT TYPE
  $('.option__wrap select').on('change', function () {
    var optionVal = $(this).val();
    var optionNum = $(this).closest('.option__wrap').attr('data-option');
    $('select[' + optionNum + ']').val(optionVal).change();
  });

  // BUTTON TYPE
  $('.option__wrap button').on('click', function (e) {
    var optionVal = $(this).attr('data-val');
    var optionNum = $(this).closest('.option__wrap').attr('data-option');

    // Set visual display of active
    $(this).closest('.option__wrap').find('button').removeClass('active');
    $(this).addClass('active');
    $('select[' + optionNum + ']').val(optionVal).change();
  });

  // RECHARE WIDGET VARIANTS
  $('.pdp__recharge input').on('click', function () {
    if ($(this).val() == 'rc-yes') {
      $('.form__group--rc').show();
      var planId = $(this).closest('.pdp__recharge').find('.frequency-select').val();
      $('[sm-rc-plan-selector]').val(planId).change();
    } else {
      $('.form__group--rc').hide();
      $('[sm-rc-plan-selector]').val('false').change();
    }
  });

  // RECHARE WIDGET SUBSCRIPTION PLAN
  $('.template__product .frequency-select').on('change', function () {
    var planId = $(this).val();
    $('[sm-rc-plan-selector]').val(planId).change();
  });
});
jQuery(document).ready(function ($) {
  // Make mobile category selector go to tag page
  $('.blog__tags select').on('change', function () {
    var tagUrl = $(this).val();
    window.location = tagUrl;
  });
});
jQuery(document).ready(function ($) {
  /******************************************
     Header Search
   ******************************************/

  // Show desktop search on click and focus on input
  $('.icon--search').on('click', function (e) {
    e.preventDefault();
    $('.desktop-search').fadeIn('fast', '', function () {
      $('body').addClass('search-open');
      $('.desktop-search input').focus();
    });
  });

  // Close desktop search if click outside
  $('body').on('click', function (e) {
    var desktopSearch = $('.desktop-search');
    if (!desktopSearch.is(e.target) && desktopSearch.has(e.target).length === 0 && $('body').hasClass('search-open')) {
      desktopSearch.fadeOut('fast', '', function () {
        $('body').removeClass('search-open');
        $('.icon--search').focus();
      });
    }
  });

  // Check for variant combinations not possible
  $('[sm-rc-option1-selector]').on('change', function () {
    $('.option__wrap option').removeAttr('disabled');
    var valOne = $(this).val();
    $('[sm-rc-variant-selector] option').each(function () {
      var valTwo = $(this).attr('data-option-2');
      if ($('[sm-rc-variant-selector] option[data-option-1="' + valOne + '"][data-option-2="' + valTwo + '"]').length > 0) {} else {
        $('.option__wrap option[value="' + valTwo + '"]').attr('disabled', 'disabled');
        $('.option__wrap--2 select').val($('.option__wrap--2 select option:not([disabled]):first').val()).change();
      }
    });
  });

  /******************************************
     Mobile Menu
   ******************************************/

  // Trigger mobile menu display
  $('.header__mobile-trigger button').on('click', function () {
    if ($(this).hasClass('is-active')) {
      setTimeout(function () {
        $('.mobile-menu__inner nav').hide();
        $('.mobile-menu__inner nav.nav--1').show();
      }, 300);
    }
    $(this).toggleClass('is-active');
    $('.mobile-menu').fadeToggle('fast', '', function () {
      $('html').toggleClass('mobile-menu-open');
    });
    if ($('.fixed-wrap').hasClass('scrolling')) {
      $('.fixed-wrap').removeClass('scrolling');
    }
  });
  $('.mobile-menu .has-children > a').on('click', function (e) {
    e.preventDefault();
    var menuID = $(this).attr('data-id');
    $(this).closest('nav').fadeOut(200, function () {
      $('.mobile-menu .sub-menu').hide();
      $('.sub-menu[data-id="' + menuID + '"]').closest('nav').fadeIn(200);
      $('.sub-menu[data-id="' + menuID + '"]').show();
    });
  });
  $('.mobile-menu .back-link a').on('click', function (e) {
    e.preventDefault();
    var menuID = $(this).attr('data-menu');
    var navID = $(this).attr('data-nav');
    $(this).closest('nav').fadeOut(200, function () {
      $('.sub-menu[data-id="' + menuID + '"]').show();
      $('.' + navID).fadeIn(200);
    });
  });

  /******************************************
     Modals
   ******************************************/

  // Launch the modal
  $('.btn--modal').on('click', function (e) {
    e.preventDefault();
    var modalID = '#' + $(this).attr('data-modal');
    if ($(this)[0].hasAttribute('data-video-yt')) {
      var videoID = $(this).attr('data-video-yt');
      $(modalID).find('.modal__inner').append('<div class="iframe-wrap"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoID + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>');
    }
    if ($(this)[0].hasAttribute('data-video-vimeo')) {
      var videoID = $(this).attr('data-video-vimeo');
      $(modalID).find('.modal__inner').append('<div class="iframe-wrap"><iframe width="560" height="315" src="https://player.vimeo.com/video/' + videoID + '"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen allowfullscreen></iframe></div>');
    }
    $(modalID).fadeIn('fast');
  });

  // Close the modal
  $('.modal--close, .modal__bg').on('click', function (e) {
    closeModal($(this));
  });
  $(window).on('load scroll', function () {
    paraScroll('.parallax .layer--mid', -0.13);
    paraScroll('.parallax .layer--bg', -0.15);
  });

  // productImageSize();

  // $( window ).on( 'resize', function(){
  //   productImageSize();
  // } )

  /******************************************
     PDP Tabs
   ******************************************/

  $('.pdp__tabs .tabs__list button').on('click', function () {
    var dataID = $(this).attr('data-id');
    if (!$(this).hasClass('active')) {
      $('.pdp__tabs .tabs__list button').removeClass('active');
      $(this).addClass('active');
      $('.pdp__tabs .tabs__tabs .tab').removeClass('tab--active');
      $('.pdp__tabs .tabs__tabs .tab[data-id="' + dataID + '"]').addClass('tab--active');
    }
  });

  // var desktopHeading = $('#desktop-heading').html();
  // mobilePdpHeading( desktopHeading );

  // $( window ).on( 'resize', function(){
  //   mobilePdpHeading( desktopHeading );
  // } )
});

function mobilePdpHeading(origin) {
  var originalContent = origin;
  if ($(window).width() < 768) {
    // Switch to new element for mobile view
    $('#desktop-heading').html('');
    $('#mobile-heading').html(originalContent);
    isMobile = true;
  } else if ($(window).width() >= 768) {
    // Switch back to original element for larger view
    $('#mobile-heading').html('');
    $('#desktop-heading').html(originalContent);
    isMobile = false;
  }
}
function productImageSize() {
  $('.product--default').each(function (index, value) {
    var imgHeight = $(this).find('.product__image').height();
    $(this).find('.product__info').css('height', 'calc( 100% - ' + imgHeight + 'px )').css('opacity', '1');
  });
}
function closeModal(object) {
  object.closest('.modal').fadeOut('fast', function () {
    $('.modal__inner .iframe-wrap').remove();
  });
}
function paraScroll(layer, offset) {
  var parallaxElement = $(layer),
    parallaxQuantity = parallaxElement.length;
  window.requestAnimationFrame(function () {
    for (var i = 0; i < parallaxQuantity; i++) {
      var currentElement = parallaxElement.eq(i),
        windowTop = $(window).scrollTop(),
        elementTop = currentElement.offset().top,
        elementHeight = currentElement.height(),
        viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
        scrolled = windowTop - elementTop + viewPortHeight;
      if (scrolled * offset >= -55) {
        currentElement.css({
          transform: 'translate3d(0,' + scrolled * offset + 'px, 0)'
        });
      }
    }
  });
}
jQuery(document).ready(function ($) {
  // Set alert bar to slider
  $('.alert-bar__slider').slick({
    infinite: true,
    slideToShow: 1,
    vertical: true,
    autoplay: true,
    dots: false,
    arrows: false,
    autoplaySpeed: 3500
  });

  // Init header offset function
  headerOffset();

  // Update offset on scroll
  $(window).on('scroll resize', function () {
    headerOffset();
  });

  // Update offset on alert bar close
  $('.alert-bar .close--alert').on('click', function () {
    $('.alert-bar').remove();
    headerOffset();
  });

  // Offset content from fixed header
  function headerOffset() {
    var alertHeight = $('.alert-bar').innerHeight();
    var headerHeight = $('.header').innerHeight();
    var fixedHeight = alertHeight + headerHeight;
    $('#main').css('padding-top', fixedHeight + 'px');
    $('.pdp__images').css('top', fixedHeight + 30 + 'px');
    $('.mobile-menu__inner, .mini-cart').css('height', 'calc( 100vh - ' + fixedHeight + 'px )');
    $(window).on('scroll resize', function () {
      var newsHeight = $('.fixed-wrap .alert-bar').innerHeight();
      if ($(window).scrollTop() >= 350) {
        $('.fixed-wrap').addClass('scrolling');
        if (newsHeight != undefined) {
          $('.fixed-wrap').css('transform', 'translateY(-' + newsHeight + 'px)');
        }
        $('.mobile-menu__inner').css('height', 'calc( 100vh - ' + fixedHeight + 'px )');
      } else {
        $('.fixed-wrap').removeClass('scrolling');
        $('.fixed-wrap').css('transform', 'translateY(0)');
      }
    });
  }
});
jQuery(document).ready(function ($) {
  // Close mini cart
  $('.mini-cart__bg, .mini-cart__content .close').on('click', function () {
    closeMini();
  });

  // Show mini cart
  $('.header .icon--cart').on('click', function (e) {
    e.preventDefault();
    if (!$('body').hasClass('template__cart')) {
      showMini();
    } else {
      e.preventDefault();
    }
  });

  // Mini Cart Remove Product
  $('.mini-cart').on('click', '.remove-product', function () {
    var lineNum = $(this).closest('.product').attr('data-lineid');
    $(this).closest('.product').addClass('removed');
    CartJS.removeItem(lineNum, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(jqXHR.responseText);
      }
    });
  });

  // Mini Cart Upsell ATC
  $('.mini-cart__upsell .action--atc').on('click', function (e) {
    e.preventDefault();
    var dataId = $(this).closest('.upsell').attr('data-id');
    CartJS.addItem(dataId, 1, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(jqXHR.responseText);
      }
    });
  });

  // Mini Cart Qty
  $('.mini-cart__list').on('click', '.js-qty--mini', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var lineData = $this.closest('.product').data('lineid');
    var lineNum = $('[data-lineID="' + lineData + '"]').index();
    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }
    CartJS.updateItem(lineNum + 1, qtyInputVal, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(jqXHR.responseText);
      }
    });
  });
});
function closeMini() {
  $('body').removeClass('cart-open');
  $('.mini-cart').removeClass('is-open');
  $('.mini-cart').fadeOut('fast');
}
function showMini() {
  $('body').addClass('cart-open');
  $('.mini-cart').fadeIn('fast');
  $('.mini-cart').addClass('is-open');

  // Set height of product list for full-height mini-cart
  // var miniHead = parseInt( $( '.mini-cart__header' ).innerHeight() );
  // var miniShip = parseInt( $( '.mini-cart__ship' ).innerHeight() );
  // var miniFooter = parseInt( $( '.mini-cart__footer' ).innerHeight() );
  // var miniUp = parseInt( $( '.mini-cart__upsell' ).innerHeight() );
  // var miniTotalHeight = miniHead + miniShip + miniFooter + miniUp;
}

function refreshMiniCart(cartData) {
  var cartItems = cartData.items;
  var newCartHtml = '';

  // Free shipping updater
  var totalShip = parseInt($('.mini-cart').data('freeship'));
  var newCartTotal = cartData.items_subtotal_price;
  var awayShip = totalShip - newCartTotal;
  var shipPercent = newCartTotal / totalShip * 100;
  if (shipPercent >= 100) {
    $('.shipping-bar--progress').css('width', '100%');
    $('.mini-cart__ship').addClass('is-free');
  } else {
    if ($('.mini-cart__ship').hasClass('is-free')) {
      $('.mini-cart__ship').removeClass('is-free');
    }
    $('.free-count').text(formatter.format(awayShip / 100));
    $('.shipping-bar--progress').css('width', shipPercent + '%');
  }
  if (cartData.item_count == 0) {
    newCartHtml += ' <h3 class="heading--six text-center" style="padding-bottom: 20px;">Cart is empty</h3>';
  } else {
    // Build html of new products in cart
    $.each(cartItems, function (index, item) {
      console.log(item);
      // Opening
      newCartHtml += '<div class="product product--cart d-flex justify-between" data-lineid="' + (index + 1) + '">';
      newCartHtml += ' <div class="product__image">';
      if (item.featured_image) {
        newCartHtml += '<a href="' + item.url + '">';
        newCartHtml += '<img src="' + item.featured_image.url.replace('.jpg', '_80x.jpg').replace('.png', '_80x.png') + '" srcset="' + item.featured_image.url.replace('.jpg', '_160x.jpg').replace('.png', '_160x.png') + ' 2x" alt="' + item.image.alt + '">';
        newCartHtml += '</a>';
      }
      newCartHtml += '</div>';
      newCartHtml += '<div class="product__info">';
      newCartHtml += '<div class="title d-flex">';
      newCartHtml += '<h3 class="heading--four d-flex justify-between">';
      newCartHtml += '<a class="no-dec trans" href="' + item.url + '">';
      newCartHtml += item.product_title;
      newCartHtml += '</a>';
      newCartHtml += ' <button class="remove-product trans"><span class="sr-only">Remove</span><img src="//dasmule.com/cdn/shop/t/14/assets/icon-close.svg?v=37438461643831647731689888904" alt="" /></button>';
      newCartHtml += '</h3>';
      if (item.properties.hasOwnProperty('_is_preorder')) {
        $.each(item.properties, function (index, value) {
          console.log('index:' + index);
          console.log('value:' + value);
          if (index == '_is_preorder') {
            newCartHtml += '<span class="pre-order">(' + value + ')</span>';
          }
        });
      }
      if (item.options_with_values != null && item.options_with_values[0].name != 'Title') {
        $.each(item.options_with_values, function (index, value) {
          newCartHtml += '<div class="var">';
          newCartHtml += '<span><span class="label">' + item.options_with_values[index].name + ':</span> ' + item.options_with_values[index].value + '</span>';
          newCartHtml += '</div>';
        });
      }
      if (item.hasOwnProperty('selling_plan_allocation')) {
        newCartHtml += '<span class="delivery">' + item.selling_plan_allocation.selling_plan.name + '</span>';
      }
      newCartHtml += '<span class="unit-price">' + formatter.format(item.price / 100) + '</span>';
      newCartHtml += '</div>';
      // newCartHtml += '<div class="price">'+formatter.format(item.final_line_price / 100)+'</div>';
      newCartHtml += "<div class=\"actions d-flex align-center justify-between\">\n            <div class=\"action action--qty\">\n              <div class=\"qty d-flex align-center\">\n                <button class=\"js-qty js-qty--mini js-qty--minus trans\">\n                  <span class=\"sr-only\">Decrease</span>\n                </button>\n                <input sm-rc-quantity-selector type=\"text\" value=\"" + item.quantity + "\" min=\"1\"  type=\"number\" class=\"qty-val\" />\n                <button class=\"js-qty js-qty--mini js-qty--plus trans\">\n                  <span class=\"sr-only\">Increase</span>\n                </button>\n              </div>\n            </div>";
      newCartHtml += '<div class="price">' + formatter.format(item.final_line_price / 100) + '</div>';
      newCartHtml += '</div>';

      // Closing
      newCartHtml += '</div>';
      newCartHtml += '</div>';
    });
  }

  // Clear current products in cart
  $('.mini-cart__items').empty();

  // Set new subtotal
  $('.mini-cart__footer .sub-total .total').text(formatter.format(cartData.total_price / 100));

  // Set new header icon count
  $('.icon--cart .cart-count span ').text(cartData.item_count);

  // Add updated producst to mini cart
  $('.mini-cart__list').html(newCartHtml);

  // Show mini cart
  showMini();
}
jQuery(document).ready(function ($) {
  // // Delay in milliseconds to hide sub-menus
  // var delayDuration = 100;

  // // Timer variable to handle delayed hiding of sub-menus
  // var hideTimer;

  // // Mouse enter event for list items
  // $('.header__nav li.has-children').mouseenter(function() {
  //   clearTimeout(hideTimer); // Clear any previous hide timer
  //   $(this).find('.sub-menu:first').fadeIn(150);
  //   var $submenu = $(this).find('ul');

  //   console.log( 'ENTER $submenu: '+ $submenu.length );
  // });

  // // Mouse leave event for list items
  // $('.header__nav li.has-children').mouseleave(function() {
  //   var $submenu = $(this).find('ul');

  //   console.log( 'EXIT $submenu: '+ $submenu.length );

  //   // Check if there's only one sub-menu
  //   if ($submenu.length === 1 && ! $( this ).find( 'ul' ).hasClass( 'sub-menu--3' ) ) {
  //     $submenu.fadeOut(150);
  //   } else {
  //     hideTimer = setTimeout(function() {
  //       $submenu.fadeOut(150);
  //     }, delayDuration);
  //   }
  // });

  $('.header__nav li[data-shop]').mouseleave(function () {
    $('.has-children .has-children a').removeClass('is-open');
    $('.has-children .has-children .sub-menu').fadeOut(200);
  });
  $('.has-children .has-children > a').on('click', function (e) {
    e.preventDefault();

    // if ( $( this ).closest( 'ul' ).hasClass( 'sub-menu--1' ) ) {
    //   $( '.sub-menu:not(.sub-menu--1)' ).fadeOut( 200 );
    // }

    $(this).closest('.sub-menu').children('li').not($(this)).each(function () {
      $(this).find('.sub-menu').fadeOut(200);
      // $('.sub-menu').css('width', '600px');
    });

    if ($(this).hasClass('is-open')) {
      $(this).removeClass('is-open');
      $(this).closest('li').find('.sub-menu').fadeOut(200);
      $(this).closest('li').find('.is-open').removeClass('is-open');
    } else {
      $('.has-children .has-children a').removeClass('is-open');
      $(this).addClass('is-open');
      $(this).next('.sub-menu').fadeIn(200);
    }
  });
});
jQuery(document).ready(function ($) {
  // Hero--full Slider
  $('.hero--slider .slider').slick({
    accessibility: false,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    appendDots: '.hero__dots .dots',
    nextArrow: '<button class="slick-next slick-arrow" data-aos-duration="650" data-aos="fade-left" aria-label="Next" type="button" style="">Next</button>',
    prevArrow: '<button class="slick-prev slick-arrow" data-aos-duration="650" data-aos="fade-right" aria-label="Previous" type="button" style="">Previous</button>',
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  });
  $('.hero--slider .slider').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    $('.hero--slider .num').hide();
    $('.hero--slider .num[data-id="' + (currentSlide + 1) + '"]').show();
    // $( '.hero__copy .inner' ).addClass( 'aos-animate' );
  });

  // $( '.hero--slider .slider' ).on('beforeChange', function(event, slick, currentSlide, nextSlide){
  //   $( '.hero__copy .inner' ).removeClass( 'aos-animate' );
  // });

  $('.cat-slider .slider').slick({
    accessibility: false,
    infinite: false,
    arrows: true,
    slidesToShow: 4,
    // slidesToScroll: 4,
    dots: false,
    variableWidth: true,
    nextArrow: '<button class="slick-next slick-arrow" data-aos-duration="650" data-aos="fade-up" aria-label="Next" type="button" style="">Next</button>',
    prevArrow: '<button class="slick-prev slick-arrow" data-aos-duration="650" data-aos="fade-up" aria-label="Previous" type="button" style="">Previous</button>',
    appendArrows: '.cat-slider .slider__heading .slider__arrows',
    responsive: [{
      breakpoint: 568,
      settings: {
        slidesToShow: 1,
        variableWidth: false,
        appendArrows: '.cat-slider .slider',
        infinite: true
      }
    }]
  });
  $('.product-slider .slider').slick({
    accessibility: false,
    infinite: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: false,
    nextArrow: '<button class="slick-next slick-arrow" data-aos-duration="650" data-aos="fade-up" aria-label="Next" type="button" style="">Next</button>',
    prevArrow: '<button class="slick-prev slick-arrow" data-aos-duration="650" data-aos="fade-up" aria-label="Previous" type="button" style="">Previous</button>',
    appendArrows: '.product-slider .slider__heading .slider__arrows',
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 568,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: '.product-slider .slider'
      }
    }]
  });
  $('.product-slider .slider--mits').slick({
    accessibility: false,
    infinite: true,
    arrows: true,
    slidesToShow: 4,
    dots: false,
    nextArrow: '<button class="slick-next slick-arrow" data-aos-duration="650" data-aos="fade-up" aria-label="Next" type="button" style="">Next</button>',
    prevArrow: '<button class="slick-prev slick-arrow" data-aos-duration="650" data-aos="fade-up" aria-label="Previous" type="button" style="">Previous</button>',
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 568,
      settings: {
        slidesToShow: 1,
        appendArrows: '.product-slider .slider--mits'
      }
    }]
  });
  $('.logo-slider .slider').slick({
    accessibility: false,
    infinite: true,
    fade: false,
    slidesToShow: 6,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 568,
      settings: 'unslick'
    }]
  });
  $('.insta-slider__slider').slick({
    speed: 10000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    pauseOnHover: true
  });

  // PDP Default image slider
  $('.pdp__images--default .pdp__slider--thumb').slick({
    accessibility: false,
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 6,
    vertical: true,
    focusOnSelect: true,
    asNavFor: '.pdp__images--default .pdp__slider--main .slider',
    responsive: [{
      breakpoint: 1280,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        vertical: false
      }
    }]
  });
  $('.pdp__images--default .pdp__slider--main .slider').slick({
    accessibility: false,
    infinite: true,
    fade: true,
    arrows: false,
    dots: false,
    asNavFor: '.pdp__images--default .pdp__slider--thumb'
  });
  $('.hero__icon-slider').slick({
    accessibility: false,
    infinite: true,
    fade: false,
    slidesToShow: 6,
    arrows: true,
    dots: false,
    nextArrow: '<button class="slick-next slick-arrow" data-aos-duration="650" data-aos="fade-left" aria-label="Next" type="button" style="">Next</button>',
    prevArrow: '<button class="slick-prev slick-arrow" data-aos-duration="650" data-aos="fade-right" aria-label="Previous" type="button" style="">Previous</button>',
    responsive: [{
      breakpoint: 1280,
      settings: {
        slidesToShow: 5
      }
    }, {
      breakpoint: 992,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 568,
      settings: {
        slidesToShow: 3,
        variableWidth: true,
        centerMode: true
      }
    }]
  });

  // Timeline
  $('.timeline .timeline__slider').slick({
    accessibility: false,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    appendDots: '.timeline .dots',
    nextArrow: '<button class="slick-next slick-arrow" data-aos-duration="650" data-aos="fade-left" aria-label="Next" type="button" style="">Next</button>',
    prevArrow: '<button class="slick-prev slick-arrow" data-aos-duration="650" data-aos="fade-right" aria-label="Previous" type="button" style="">Previous</button>',
    responsive: [{
      breakpoint: 768,
      settings: {
        appendArrows: '.timeline .timeline-arrows'
      }
    }]
  });

  // Team
  $('.team-slider  .slider').slick({
    accessibility: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    nextArrow: '<button class="slick-next slick-arrow" data-aos-duration="650" data-aos="fade-left" aria-label="Next" type="button" style="">Next</button>',
    prevArrow: '<button class="slick-prev slick-arrow" data-aos-duration="650" data-aos="fade-right" aria-label="Previous" type="button" style="">Previous</button>',
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 568,
      settings: {
        slidesToShow: 1
      }
    }]
  });
});
// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file. 

console.log('%c This site is kept alive by https://www.shiftds.com', 'background:#000; color: #ae956e; padding: 10px 15px; font-size: 13px; font-weight: 500; width: 100%;');

// Create our number formatter.
var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

// Cookies functions
function setCookie(cookieName, cookieValue) {
  var today = new Date();
  var expire = new Date();
  expire.setTime(today.getTime() + 3600000 * 24 * 7);
  document.cookie = cookieName + "=" + encodeURI(cookieValue) + ";expires=" + expire.toGMTString();
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// Variant image slider - BD

jQuery(document).ready(function ($) {
  
  // Add some debugging
  console.log('Variant swap script loaded');
  
  // Function to update image sliders and product info based on variant
  function updateVariantDisplay(variantId) {
    console.log('Updating variant display for ID:', variantId);
    
    // Find the selected variant option element
    var $selectedVariant = $('select[sm-rc-variant-selector] option[value="' + variantId + '"]');
    console.log('Found variant option:', $selectedVariant.length);
    
    if ($selectedVariant.length) {
      // Update SKU
      var variantSku = $selectedVariant.data('sku') || '';
      console.log('Variant SKU:', variantSku);
      
      // Update the SKU display
      var $skuElement = $('.sku');
      console.log('Found SKU element:', $skuElement.length);
      
      if ($skuElement.length) {
        if (variantSku && variantSku !== '') {
          $skuElement.text('SKU: ' + variantSku).show();
          console.log('Updated SKU to:', variantSku);
        } else {
          $skuElement.hide(); // Hide SKU if variant doesn't have one
          console.log('Hiding SKU - no SKU for this variant');
        }
      }
      
      // Update Images
      var variantImageUrl = $selectedVariant.data('image');
      console.log('Variant image URL:', variantImageUrl);
      
      if (variantImageUrl && variantImageUrl !== '') {
        // Try a simpler approach - look for the exact image URL match first
        var $mainSlider = $('.pdp__slider--main .slider');
        var $thumbSlider = $('.pdp__slider--thumb');
        
        console.log('Main slider found:', $mainSlider.length);
        console.log('Thumb slider found:', $thumbSlider.length);
        
        var slideIndex = -1;
        
        // Extract the base filename from variant image (everything before the size)
        var variantBaseFilename = variantImageUrl.split('_150x150')[0];
        if (variantBaseFilename.indexOf('//') !== -1) {
          variantBaseFilename = variantBaseFilename.split('/').pop();
        }
        console.log('Looking for base filename:', variantBaseFilename);
        
        // Check each slide for matching image
        $mainSlider.find('.slick-slide').each(function(index) {
          var $slideImage = $(this).find('img');
          if ($slideImage.length) {
            var slideSrc = $slideImage.attr('src');
            console.log('Checking slide ' + index + ' image:', slideSrc);
            
            // Check if the slide image contains the same base filename
            if (slideSrc && slideSrc.indexOf(variantBaseFilename) !== -1) {
              slideIndex = index;
              console.log('Found matching slide at index:', slideIndex);
              return false; // Break the loop
            }
          }
        });
        
        // If we found a matching slide, navigate to it
        if (slideIndex !== -1) {
          console.log('Navigating sliders to slide:', slideIndex);
          $mainSlider.slick('slickGoTo', slideIndex);
          $thumbSlider.slick('slickGoTo', slideIndex);
        } else {
          console.log('No matching slide found for variant image');
        }
      } else {
        console.log('No variant image URL found');
      }
    } else {
      console.log('No variant option found for ID:', variantId);
    }
  }
  
  // Listen for changes on the hidden SM-RC variant selector
  $('select[sm-rc-variant-selector]').on('change', function() {
    var selectedVariantId = $(this).val();
    console.log('SM-RC selector changed to:', selectedVariantId);
    updateVariantDisplay(selectedVariantId);
  });
  
  // Also listen for changes on the visible option selectors
  $('.option__wrap select').on('change', function() {
    console.log('Visible option selector changed');
    // Small delay to ensure the SM-RC selector has been updated
    setTimeout(function() {
      var selectedVariantId = $('select[sm-rc-variant-selector]').val();
      console.log('After timeout, SM-RC selector value:', selectedVariantId);
      updateVariantDisplay(selectedVariantId);
    }, 100);
  });
  
  // Handle button-type variant selectors if you're using them
  $('.option__wrap button').on('click', function() {
    console.log('Variant button clicked');
    // Small delay to ensure the SM-RC selector has been updated
    setTimeout(function() {
      var selectedVariantId = $('select[sm-rc-variant-selector]').val();
      console.log('After button click timeout, SM-RC selector value:', selectedVariantId);
      updateVariantDisplay(selectedVariantId);
    }, 100);
  });
  
  // Let's also try listening to the original variant change events that might be working
  $(document).on('change', 'select[sm-rc-variant-selector]', function() {
    var selectedVariantId = $(this).val();
    console.log('Document-level SM-RC selector changed to:', selectedVariantId);
    updateVariantDisplay(selectedVariantId);
  });
  
  // Debug: Log what elements we can find on page load
  console.log('Available variant selector:', $('select[sm-rc-variant-selector]').length);
  console.log('Available option selectors:', $('.option__wrap select').length);
  console.log('Available SKU elements:', $('.sku').length);
  console.log('Available main sliders:', $('.pdp__slider--main .slider').length);
  console.log('Available thumb sliders:', $('.pdp__slider--thumb').length);
  
});